/**
 * hooks/handlers/formHooks.ts — UPDATED
 *
 * ADD the new imports and entries at the bottom.
 * Keep all existing entries unchanged.
 */

import { usePasswordResetForm } from "../auth/usePasswordResetForm";
import { useConfirmDeliveryForm } from "../devices/useConfirmDeliveryForm";
import { useDeviceOrderForm } from "../devices/useDeviceOrderForm";
import { usePayDepositForm } from "../devices/usePayDepositForm";
import { useFundLoanForm } from "../loans/useFundLoanForm";
import { useLoansForm } from "../loans/useLoansForm";
import { useLoanOfferAcceptForm } from "../loans/useLoanOfferAcceptForm";
import { useEarlySettlementForm } from "../loans/useEarlySettlementForm";
import { useLoginForm } from "../login/useLoginForm";
import { useRegisterForm } from "../register/useRegisterForm";
import { useRepayForm } from "../repayments/useRepayForm";
import { useTransferForm } from "../transfer/useTransferForm";
import { useWalletsForm } from "../wallets/useWalletsForm";

// ── Phase 6: Manual Operations ──────────────────────────────────
import { useDepositForm } from "../deposits/useDepositForm";
import { useWithdrawalForm } from "../withdrawals/useWithdrawalForm";
import { useManualRepaymentForm } from "../manual-repayments/useManualRepaymentForm";
import { useBankAccountForm } from "../accounts/useBankAccountForm";
import { useMomoAccountForm } from "../accounts/useMomoAccountForm";

export const formHooks: any = {
  register: useRegisterForm,
  login: useLoginForm,
  top_up: useWalletsForm,
  withdraw: useWalletsForm,
  loans: useLoansForm,
  fund_loan: useFundLoanForm,
  password_reset: usePasswordResetForm,
  repay: useRepayForm,
  transfer: useTransferForm,

  // Device financing
  order_device: useDeviceOrderForm,
  pay_deposit: usePayDepositForm,
  confirm_delivery: useConfirmDeliveryForm,

  // Loan offer + early settlement
  accept_offer: useLoanOfferAcceptForm,
  early_settle: useEarlySettlementForm,

  // ── Phase 6: Manual Operations ──
  new_manual_deposit: useDepositForm,
  new_manual_withdrawal: useWithdrawalForm,
  submit_manual_repayment: useManualRepaymentForm,
  add_bank_account: useBankAccountForm,
  add_momo_account: useMomoAccountForm,
};